import { TransferResponse } from 'models/DealRoom';
import { useCallback, useContext } from 'react';
import DealContext from '../providers/Deal';
import ListingContext from '../providers/Listing/Listing.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

export default function useTransferDeal() {
  const {
    currentUser: { _id: currentUserId },
  } = useContext(CurrentUserContext);
  const { setListing } = useContext(ListingContext);
  const { onNewOwner, setDealRoom } = useContext(DealContext);

  const updateProvidersAfterDealTransfer = useCallback(
    ({ colleague, deal }: TransferResponse) => {
      onNewOwner(colleague);
      setDealRoom((prev) => ({ ...prev, ...deal }));
      setListing((prev) => ({
        ...prev,
        isOwner: colleague?.userId === currentUserId,
      }));
    },
    [onNewOwner, setDealRoom, setListing, currentUserId],
  );

  return { updateProvidersAfterDealTransfer };
}
